import { Tag } from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const StyledTag = styled(Tag)`
  margin: 0;
`;

export const GlobalModalStyles = createGlobalStyle`
  .docs-modal {
    width: 588px !important;
    margin: 10% auto;
    padding: 0;

      .ant-modal-content {
        .ant-col-32 {
            display: flex;
            align-items: center;
            margin-left: 14px;
            margin-bottom: 28px;

            > svg {
              margin-right: 16px;
            }

            > a {
              max-width: calc(100% - 48px);

              > .ant-typography {
                color: ${"#007BFB"};
                font-weight: 400;
              }
            }
          }
      .ant-modal-header {
        padding-bottom: 20px;

        .ant-row {
          margin: 0;
        }
      }

      .ant-modal-body {
        padding-bottom: 32px;

        .docs-header-row {
          padding: 0 16px 8px;
          border-bottom: 1px solid ${"#f5f5f5"};

          .ant-typography.ant-typography-secondary {
            color: ${"#8c8c8c"};
            font-weight: 500;
          }
        }

        .docs-modal-row {
          padding: 18px 16px;

          .ant-btn.ant-btn-link {
            padding: 0;
            height: 16px;
            max-width: calc(100% - 54px);
            margin-right: 8px;

            > span {
              color: ${"#1677ff"};
              font-weight: 500;
              line-height: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: block;
            }
          }

          .ant-col-14 {
            display: flex;
            align-items: center;

            > svg {
              margin-right: 16px;
            }

            > a {
              max-width: calc(100% - 48px);

              > .ant-typography {
                color: ${"#007BFB"};
                font-weight: 400;
              }
            }
          }

          .ant-col-8 .ant-typography {
              font-weight: 500;
              line-height: 16px;
          }
        }

        .docs-modal-row:not(:last-child) {
          border-bottom: 1px solid ${"#f5f5f5"};
        }
      }
    }
  }
`;
